import { render } from "./VueGeofenciesListItem.vue?vue&type=template&id=520f4392&scoped=true"
import script from "./VueGeofenciesListItem.vue?vue&type=script&lang=js"
export * from "./VueGeofenciesListItem.vue?vue&type=script&lang=js"

import "./VueGeofenciesListItem.vue?vue&type=style&index=0&id=520f4392&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520f4392"]])

export default __exports__